<nz-tabset>
  <nz-tab nzTitle="Audio tools">
    <ukata-maker-sidebar></ukata-maker-sidebar>
  </nz-tab>
  <nz-tab nzTitle="Words Extractor">
    <ukata-words-extractor></ukata-words-extractor>
  </nz-tab>
</nz-tabset>
